import { IACSJobDetails } from 'interfaces/Jobs/IACSJobDetails';
import { IACSJobRequest } from 'interfaces/Jobs/IACSJobRequest';
import { IApplyJobRequest } from 'interfaces/Jobs/IApplyJobRequest';
import { IJobDetailRequest } from 'interfaces/Jobs/IJobDetailRequest';
import { IJobRequest } from 'interfaces/Jobs/IJobsRequest';
import { ISimilarJobsRequest } from 'interfaces/Jobs/ISimilarJobsRequest';
import { http } from 'services/BaseApi';

export const fetchJobs = async (jobRequest: IJobRequest): Promise<string> => {
  let jobSearchQuery = `jobs/${jobRequest.userId}?&limit=${jobRequest.limit}`;

  if (jobRequest.sort) jobSearchQuery += `&sort=${jobRequest.sort}`;
  if (jobRequest.offset) jobSearchQuery += `&offset=${jobRequest.offset}`;
  if (jobRequest.isFavorite)
    jobSearchQuery += `&isFavorite=${jobRequest.isFavorite}`;
  if (jobRequest.maxRadius)
    jobSearchQuery += `&maxRadius=${jobRequest.maxRadius}`;
  return await http.get<string>(jobSearchQuery);
};

export const fetchJobsV2 = async (
  jobRequest: IACSJobRequest,
): Promise<string> => {
  const queryString = queryStringBuilder(jobRequest);
  let jobSearchQuery = `v2/jobs/${jobRequest.userId}?&SourceSystem=AMIE${queryString}`;

  return await http.get<string>(jobSearchQuery);
};

export const postFavorite = async (postFavouriteRequest): Promise<boolean> => {
  return await http.post<any>(
    `jobs/${postFavouriteRequest.userId}/${postFavouriteRequest.jobId}/favorite`,
  );
};

export const deleteFavorite = async (
  deleteFavouriteRequest,
): Promise<boolean> => {
  return await http.delete<any>(
    `jobs/${deleteFavouriteRequest.userId}/${deleteFavouriteRequest.jobId}/favorite`,
  );
};

export const fetchJobDetails = async (
  jobRequest: IJobDetailRequest,
): Promise<any> => {
  return await http.get<any>(`jobs/${jobRequest.userId}/${jobRequest.jobId}`);
};

export const fetchJobDetailsV2 = async (
  jobRequest: IJobDetailRequest,
): Promise<IACSJobDetails> =>
  await http.get<string>(`v2/jobs/${jobRequest.userId}/${jobRequest.jobId}`);

export const postApplyJob = async (
  applyJobRequest: IApplyJobRequest,
): Promise<boolean> => {
  return await http.post<any>(
    `jobs/${applyJobRequest.userId}/${applyJobRequest.jobId}/apply`,
    applyJobRequest,
  );
};

export const fetchSimilarJobs = async (
  similarJobRequest: ISimilarJobsRequest,
): Promise<string> => {
  let similarJobSearchQuery = `jobs/${similarJobRequest.userId}/${similarJobRequest.jobId}/similar`;
  return await http.get<string>(similarJobSearchQuery);
};

export const fetchStrikeJobs = async (userId: string): Promise<string> => {
  const strikeJobSearchQuery = `jobs/${userId}/strike`;
  return await http.get<string>(strikeJobSearchQuery);
};

const queryStringBuilder = (jobRequest: IACSJobRequest) => {
  let queryString: string[] = [];

  if (jobRequest.keywordSearch)
    queryString.push(`&KeywordSearch=${jobRequest.keywordSearch}`);
  if (jobRequest.locationSearch)
    queryString.push(`&LocationSearch=${jobRequest.locationSearch}`);
  if (jobRequest.locationDistance)
    queryString.push(`&LocationDistance=${jobRequest.locationDistance}`);
  if (jobRequest.pageNumber)
    queryString.push(`&PageNumber=${jobRequest.pageNumber}`);
  if (jobRequest.pageSize) queryString.push(`&PageSize=${jobRequest.pageSize}`);
  if (jobRequest.orderBy) queryString.push(`&OrderBy=${jobRequest.orderBy}`);

  if (jobRequest.filterTypes) {
    queryString.push(
      `&FilterTypes=${jobRequest?.filterTypes
        ?.map(x => x.filterType)
        .join('&FilterTypes=')}`,
    );
  }
  const isValueExists = jobRequest.filterTypes?.some(
    x => x.values && x.values.length > 0,
  );
  if (isValueExists) {
    queryString.push(
      `&Filters=${jobRequest.filterTypes
        ?.filter(x => x.values && x.values.length > 0)
        ?.map(
          x =>
            `${x.filterType}${
              x.values && x.values?.length > 0
                ? ':' +
                  x.values
                    ?.filter(x => x?.displayName)
                    ?.map(x => x?.displayName)
                    .join(',')
                : ''
            }`,
        )
        .join('&Filters=')}`,
    );
  }

  return queryString.join('');
};
